$(document).ready(function() {

  // Simulator
  $('#my_net_annual_income, #my_liquid_assets, #my_annual_financial_commitments').each(function() {
    if ($(this).val() != '') {
      $('#calculate_results').removeClass('disabled');
    }
  });

  // Disable #calculate_results button if calculation fields are empty
  // In v2, the button is hidden — auto-calculate on keyup instead
  $('#my_net_annual_income, #my_liquid_assets, #my_annual_financial_commitments').on('keyup', function() {
    const hasAnyValue = $('#my_net_annual_income').val() != '' ||
                        $('#my_liquid_assets').val() != '' ||
                        $('#my_annual_financial_commitments').val() != '';
    if (hasAnyValue) {
      $('#calculate_results').removeClass('disabled');
    } else {
      $('#calculate_results').addClass('disabled');
    }

    if ($('#calculate_results').parent().hasClass('d-none')) {
      calculateResults();
    }
  });

  $('#calculate_results').on('click', function() {
    calculateResults();
  });

  let calculateResults = () => {
    let my_annual_income = $('#my_net_annual_income').val();
    let formatted_annual_income = my_annual_income.replace(/[^0-9]/g, '') || 0;

    let my_liquid_assets = $('#my_liquid_assets').val();
    let formatted_liquid_assets = my_liquid_assets.replace(/[^0-9]/g, '') || 0;

    let my_annual_financial_commitments = $('#my_annual_financial_commitments').val();
    let formatted_annual_financial_commitments = my_annual_financial_commitments.replace(/[^0-9]/g, '') || 0;

    let my_net_patrimony = parseInt(formatted_annual_income) +
                           parseInt(formatted_liquid_assets) -
                           parseInt(formatted_annual_financial_commitments);
    my_net_patrimony = my_net_patrimony < 0 ? 0 : my_net_patrimony;

    let losses_capacity_text = my_net_patrimony * 0.1

    $('#my_net_patrimony').val(formatAmount(my_net_patrimony));
    $('#my_losses_capacity').val(formatAmount(losses_capacity_text));
    $('#losses_capacity_text').text(formatAmount(losses_capacity_text));

    const isQualified = $('.risk-profile').data('risk-profile') == 'qualified'

    if (isQualified && losses_capacity_text > 1000) {
      $('#finalize-simulation .submit-btn').removeClass('d-none');
      $('.simulator_accept_terms_radio_btn').attr('required', false);

      $('#finalize-simulation .submit-btn').prop('disabled', false);
      $('#finalize-simulation .modale-btn').addClass('d-none');
    } else {
      $('#finalize-simulation .submit-btn').addClass('d-none');
      $('.simulator_accept_terms_radio_btn').attr('required', 'required');

      $('#finalize-simulation .submit-btn').prop('disabled', true);
      $('#finalize-simulation .modale-btn').removeClass('d-none');
    }
  }

  let formatAmount = (amount) => {
    return new Intl.NumberFormat(getCurrentLocale(), { currency: 'EUR' }).format(amount)
  }

  // Recompute results on page load when the fields are already filled
  if ($('#my_net_annual_income').val() &&
      $('#my_liquid_assets').val() &&
      $('#my_annual_financial_commitments').val()) {
    calculateResults();
  }
  // End Simulator

  // Anti money laundering

  // Submit button state
  let hideDisqualifiedBtn = () => {
    $('.finalize-aml-btn').removeClass('d-none');
    $('.disqualified-btn').addClass('d-none');
  }

  let hideFinalizeBtn = () => {
    $('.disqualified-btn').removeClass('d-none');
    $('.finalize-aml-btn').addClass('d-none');
  }

  if ($('#suitability_questionnaire_certify_legal_funds_answer_1').is(':checked')) {
    hideDisqualifiedBtn();
  } else {
    hideFinalizeBtn();
  };

  $('#suitability_questionnaire_certify_legal_funds_answer_1').on('click', function() {
    hideDisqualifiedBtn();
  });

  $('#suitability_questionnaire_certify_legal_funds_answer_2').on('click', function() {
    hideFinalizeBtn();
  });
  // End Anti money laundering

  // Informed
  let hideProfessionalActivity = () => {
    $('.is_top_executive').removeClass('d-none');
    $('.professional_activity').addClass('d-none');
  }

  let hideIsTopExecutive = () => {
    $('.professional_activity').removeClass('d-none');
    $('.is_top_executive').addClass('d-none');
  }

  if($('.informed').length) {
    if ($('#suitability_questionnaire_has_investment_experience_true').is(':checked')) {
      hideIsTopExecutive();
    } else if ($('#suitability_questionnaire_has_investment_experience_false').is(':checked')){
      hideProfessionalActivity();
    } else {
      $('.professional_activity, .is_top_executive').addClass('d-none');
    }

    $('#suitability_questionnaire_has_investment_experience_true').on('click', function() {
      hideIsTopExecutive();
    });

    $('#suitability_questionnaire_has_investment_experience_false').on('click', function() {
      hideProfessionalActivity();
    });
  }
  // end Informed
})
